import React from "react";
import styles from "./variantDrawerDeliveryCycleInfo.scss";

export default function DeliveryCycleInfo({ deliveryDescriptionArray }) {
  return deliveryDescriptionArray ? (
    <div className={styles["deliveryCycleInfo_main_div"]}>
      <div className={styles["deliveryCycleInfo_container"]}>
        <div className={styles["deliveryCycleInfo_div"]}>
          <span className={styles["deliveryCycleInfoText"]}>
            配送週期說明 :
          </span>
          <div className={styles["description_div"]}>
            {deliveryDescriptionArray
              ? deliveryDescriptionArray.map((value, index) => (
                <div
                  key={index}
                  className={styles["delivery-instructions"]}
                  style={{
                    marginBottom:
                      index != deliveryDescriptionArray?.length - 1
                        ? "14px"
                        : null,
                  }}
                >
                  <div>{index + 1}.&nbsp;</div>
                  <div>{value}</div>
                </div>
              ))
              : null}
          </div>
        </div>
      </div>
      <div className={styles["caution_main_div"]}>
        <div className={styles["caution_div"]}>
          <div className={styles["icon_and_text"]}>
            <svg
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.78125 7.35547L7.97266 10.418C7.97266 10.6094 8.10938 10.7188 8.30078 10.7188H9.42188C9.61328 10.7188 9.75 10.582 9.75 10.418L9.94141 7.35547C9.94141 7.16406 9.80469 7 9.61328 7H8.10938C7.91797 7 7.78125 7.16406 7.78125 7.35547ZM10.0234 12.25C10.0234 11.6211 9.50391 11.1016 8.875 11.1016C8.21875 11.1016 7.72656 11.6211 7.72656 12.25C7.72656 12.9062 8.21875 13.3984 8.875 13.3984C9.50391 13.3984 10.0234 12.9062 10.0234 12.25ZM9.99609 2.40625C9.50391 1.55859 8.21875 1.53125 7.72656 2.40625L1.16406 13.8086C0.671875 14.6562 1.30078 15.75 2.3125 15.75H15.4102C16.4219 15.75 17.0508 14.6836 16.5586 13.8086L9.99609 2.40625ZM2.44922 14.2188L8.71094 3.33594C8.79297 3.22656 8.92969 3.22656 9.01172 3.33594L15.2734 14.2188C15.3555 14.3281 15.2734 14.4375 15.1367 14.4375H2.58594C2.44922 14.4375 2.36719 14.3281 2.44922 14.2188Z"
                fill="#A36A00"
              />
            </svg>
            <div className={styles["text"]}>此區商品數量僅能選一個</div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
